var STRINGS = {
    startText: 'PRESS START',
    gameOverText: 'GAME OVER.'
};

module.exports = STRINGS;



/*****************
 ** WEBPACK FOOTER
 ** ./src/gradience/config/strings.js
 ** module id = 28
 ** module chunks = 0
 **/